module.exports = __webpack_public_path__ + "static/media/items.32e304b3.svg";